module.exports = __webpack_public_path__ + "img/per4.36711d98.png";